<template>
	<div>
		<Header :logo="`${imgPath}/static/assets/img/brand/2/logo.png`" :width="1.48" />
		<div class="bannerWrap">
			<img class="bannerImg" :src="`${imgPath}/static/assets/img/brand/2/banner.jpg`" />
			<cloud />
		</div>
		<div class="brandWrap brand2" :class="{'zh-cn': lang=='zh-cn','en-us':lang == 'en-us'}">
			<div class="brandWrapModule" :class="{'zhw': lang=='zh-cn'}">
			<p :class="{'field_1 item_center': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_1"></p>
			<p :class="{'field_2 item_center': lang=='zh-cn', 'field_4':lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.59rem' : '0.62rem' }" v-html="detail.field_2"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.2rem' : '0.92rem' }"><img :src="detail.field_3" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.52rem' : '1.17rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_4"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.72rem' : '0.65rem' }" v-html="detail.field_5"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.15rem' : '0.94rem' }"><img :src="detail.field_6" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.54rem' : '1.14rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_7"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.6rem' : '0.63rem' }" v-html="detail.field_8"></p>
			</div>
			<p class="brandImg_style2" :style="{ 'marginTop': lang=='zh-cn'? '1.41rem' : '1.3rem' }"><img :src="detail.field_9" width="100%" /></p>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.45rem' : '1.59rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_10"></p>
				<p :class="{'field_2': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.76rem' : '0.63rem' }" v-html="detail.field_11"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.51rem' : '0.76rem' }"><img :src="detail.field_12" width="100%" /></p>
			<div class="brandListWrap">
				<p class="title item_center" v-html="detail.field_13"></p>
				<div class="brandListItem" :style="{ 'marginTop': lang=='zh-cn'? '0.8rem' : '0.85rem' }">
					<img :src="detail.field_14" width="100%" />
					<p class="item_center" v-html="detail.field_15"></p>
				</div>
				<div class="brandListItem">
					<img :src="detail.field_16" width="100%" />
					<p class="item_center" v-html="detail.field_17"></p>
				</div>
				<div class="brandListItem">
					<img :src="detail.field_18" width="100%" />
					<p class="item_center" v-html="detail.field_19"></p>
				</div>
			</div>
			<div class="brandWrapModule" :style="{ 'marginTop': lang=='zh-cn'? '1.7rem' : '1.59rem' }">
				<p :class="{'field_1': lang=='zh-cn', 'field_3': lang == 'en-us'}" v-html="detail.field_20"></p>
				<p class="field_3" :style="{ 'marginTop': lang=='zh-cn'? '0.12rem' : '0' }" v-html="detail.field_21"></p>
				<p :class="{'field_2 height_50': lang=='zh-cn', 'field_4': lang == 'en-us'}" :style="{ 'marginTop': lang=='zh-cn'? '0.78rem' : '0.55rem' }" v-html="detail.field_22"></p>
			</div>
			<p class="brandImg_style1" :style="{ 'marginTop': lang=='zh-cn'? '1.61rem' : '1.2rem' }"><img :src="detail.field_23" width="100%" /></p>
			<a class="brandLinkWrap bg2" href="http://www.ovv.cn" target="_blank">
				<p class="brandLink1">{{ $t('shoplink') }}</p>
				<p class="brandLink2">www.ovv.cn</p>
				<img class="linkIcon" :src="`${imgPath}/static/assets/img/brand/linkImg.png`" />
			</a>
			<top />
			<div class="cloudImg">
				<img :src="`${imgPath}/static/assets/img/cloud.png`" />
			</div>
			<bottom />
		</div>
	</div>
</template>
<script>
export default {
    data(){
		return{
			detail:{},
			lang: this.$route.query.lang || localStorage.getItem('language')||'zh-cn'
		}
	},
	async mounted() {
		let res = await this.$util.getBrandDetail(9)
		this.detail = res;
	},
	methods:{
	}
}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/brandStyle.scss";
</style>


// WEBPACK FOOTER //
// src/views/brand/brand2.vue